/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type BrokerProfileLinkResponseDtoType = typeof BrokerProfileLinkResponseDtoType[keyof typeof BrokerProfileLinkResponseDtoType];


export const BrokerProfileLinkResponseDtoType = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  YOUTUBE: 'YOUTUBE',
  LINKEDIN: 'LINKEDIN',
  TIKTOK: 'TIKTOK',
  WEBSITE: 'WEBSITE',
  OTHER: 'OTHER',
} as const;
